/**
 * @generated SignedSource<<6e3b9cbe44cb11df258eda45d882f67e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
export type UpdateCompanyInternalDataInput = {
  companyId: number;
  datacenter?: string | null;
  trialEndYear?: number | null;
  trialEndMonth?: number | null;
  trialEndDay?: number | null;
  tier?: TierType | null;
  accessBlocked?: boolean | null;
  name?: string | null;
  street?: string | null;
  zip?: string | null;
  city?: string | null;
  country?: string | null;
  vatId?: string | null;
  contactName?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  seats?: number | null;
  virtualSeats?: number | null;
  sisenseViewerSeats?: number | null;
  sisenseDesignerSeats?: number | null;
  syncWithSF?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateCompanyInternalDataMutation$variables = {
  input: UpdateCompanyInternalDataInput;
};
export type updateCompanyInternalDataMutation$data = {
  readonly UpdateCompanyInternalData: {
    readonly MissionControlCompanyStats: {
      readonly id: string;
      readonly companyId: number | null;
      readonly companyName: string | null;
      readonly tier: TierType | null;
      readonly trialEndDate: string | null;
      readonly numOfProjects: number | null;
      readonly numOfCards: number | null;
      readonly numActivePersons: number | null;
      readonly numTimeRegs: number | null;
      readonly accessBlocked: boolean | null;
      readonly userSeats: number | null;
      readonly virtualSeats: number | null;
      readonly numOfClientUsers: number | null;
      readonly numVirtualUsers: number | null;
      readonly sisenseViewerSeats: number | null;
      readonly sisenseDesignerSeats: number | null;
    } | null;
  } | null;
};
export type updateCompanyInternalDataMutation = {
  variables: updateCompanyInternalDataMutation$variables;
  response: updateCompanyInternalDataMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCompanyInternalDataPayload",
    "kind": "LinkedField",
    "name": "UpdateCompanyInternalData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlCompanyStatsType",
        "kind": "LinkedField",
        "name": "MissionControlCompanyStats",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trialEndDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numOfProjects",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numOfCards",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numActivePersons",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numTimeRegs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accessBlocked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userSeats",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "virtualSeats",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numOfClientUsers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numVirtualUsers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sisenseViewerSeats",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sisenseDesignerSeats",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCompanyInternalDataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCompanyInternalDataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8b8ea43b5d02f93d4c3186f5a13a1214",
    "id": null,
    "metadata": {},
    "name": "updateCompanyInternalDataMutation",
    "operationKind": "mutation",
    "text": "mutation updateCompanyInternalDataMutation(\n  $input: UpdateCompanyInternalDataInput!\n) {\n  UpdateCompanyInternalData(input: $input) {\n    MissionControlCompanyStats {\n      id\n      companyId\n      companyName\n      tier\n      trialEndDate\n      numOfProjects\n      numOfCards\n      numActivePersons\n      numTimeRegs\n      accessBlocked\n      userSeats\n      virtualSeats\n      numOfClientUsers\n      numVirtualUsers\n      sisenseViewerSeats\n      sisenseDesignerSeats\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f5fa99b86fb30c2c686911606f116e7c";

export default node;
